import { CatalogItemViewModel } from '@common/model/catalog/item/view';

export const printAddress = (data: CatalogItemViewModel | undefined, options: { streetOnly?: boolean } = {}) => {
  if (!data) {
    return '';
  }

  const address: string = (data.address ?? '').trim();

  return `${data.city?.translation.name ?? ''}, ${options.streetOnly ? address.split(',')[0] : address}`;
};

export const useAddress = printAddress;
